<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['companies.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'COMPANIES.COMPANIES_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER], ['companies.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'COMPANIES.COMPANIES_LIST.ADD_COMPANY' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="companiesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Companies', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'COMPANIES.COMPANIES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'COMPANIES.COMPANIES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'COMPANIES.COMPANIES_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="d-flex">
          <div
            class="company-img"
            *ngIf="dataItem.logo"
            [style.background-image]="dataItem.logo && getBackgroundImg(dataItem.logo)"
          ></div>
          <a [routerLink]="['/settings/companies/view']" [queryParams]="{ id: dataItem.id }" target="_blank">
            {{ dataItem.name }}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="abbreviation"
      title="{{ 'COMPANIES.COMPANIES_LIST.ABBREVIATION' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('abbreviation')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/settings/companies/view']" [queryParams]="{ id: dataItem.id }" target="_blank">
          {{ dataItem.abbreviation }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="registration_number"
      title="{{ 'COMPANIES.COMPANIES_LIST.REGISTRATION_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('registration_number')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="tax_number"
      title="{{ 'COMPANIES.COMPANIES_LIST.TAX_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('tax_number')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="vat_number"
      title="{{ 'COMPANIES.COMPANIES_LIST.VAT_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('vat_number')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="iata_tids_number"
      title="{{ 'COMPANIES.COMPANIES_LIST.IATA_TIDS_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('iata_tids_number')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="vat_percent"
      title="{{ 'COMPANIES.COMPANIES_LIST.VAT_PERCENT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('vat_percent', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="proforma_prefix"
      title="{{ 'COMPANIES.COMPANIES_LIST.PROFORMA_PREFIX' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('proforma_prefix', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="invoice_digits_count"
      title="{{ 'COMPANIES.COMPANIES_LIST.INVOICE_DIGITS_COUNT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('invoice_digits_count', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="city.name"
      title="{{ 'COMPANIES.COMPANIES_LIST.CITY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('city.name')"
      [filterable]="false"
      [sortable]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem?.city?.name }}
        <span *ngIf="dataItem?.city?.country">({{ dataItem?.city?.country?.name }})</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="address"
      title="{{ 'COMPANIES.COMPANIES_LIST.ADDRESS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('address')"
    ></kendo-grid-column>

    <kendo-grid-column
      title="{{ 'COMPANIES.COMPANIES_LIST.WEBSITES' | translate }}"
      [hidden]="isHiddenColumn('websites')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngFor="let website of dataItem.websites; let i = index">
          <a [href]="website?.url" target="_blank"> {{ website.name }}</a>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="{{ 'COMPANIES.COMPANIES_LIST.CONTACTS' | translate }}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngFor="let contact of dataItem.contacts; let i = index">
          <span class="contact-key">{{ contact?.type?.value }}:</span>
          <span class="contact-value">{{ contact?.value }}</span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'COMPANIES.COMPANIES_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="120"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'COMPANIES.COMPANIES_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-preview-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              ['companies.show']
            )
          "
          [link]="['/settings/companies/view']"
          [params]="{ id: dataItem.id }"
        >
        </app-preview-button>

        <app-edit-button
          *ngIf="
            accessService.hasAccess([UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER], ['companies.show'])
          "
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-delete-button
          *ngIf="
            accessService.hasAccess([UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER], ['companies.destroy'])
          "
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>

        <app-media-library-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER
              ],
              ['media.index']
            )
          "
          [ngbTooltip]="'COMPANIES.COMPANIES_LIST.UPLOAD_DOCUMENTS' | translate"
          container="body"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.COMPANY"
          [collectionName]="'documents'"
          [acceptType]="MediaLibraryAcceptTypes.ALL"
          [icon]="'fal fa-file'"
        ></app-media-library-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.ADMINISTRATOR], ['media.index'])"
          [ngbTooltip]="'COMPANIES.COMPANIES_LIST.UPLOAD_SALE_VOUCHER_TEMPLATE' | translate"
          container="body"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.COMPANY"
          [collectionName]="'sale_vouchers'"
          [acceptType]="MediaLibraryAcceptTypes.DOC"
          [icon]="'fal fa-file-word'"
        ></app-media-library-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
